
import * as React from 'react';

import { useToken } from "./token_context";
import { useMessage } from "./message_context";
import { usePageContext } from "./page_context";


async function getAllTokens(access_token) {
    if (!access_token.token) return [];
    const res = await fetch("/api/model/tokens?_t=" + access_token.token);
    return await res.json();
}


export function AccessTokenList() {
    const { token } = useToken();
    const { message } = useMessage();
    const { page_state, setPageState } = usePageContext();


    const [ token_list, setTokenList ] = React.useState();

    function editToken(token) {
        setPageState({
            admin_tokens_active: true,
            edit_token_dialog_open: true,
            edit_token_id: token
        });
    }


    React.useEffect(() => {
        getAllTokens(token).then((rc) => {
            if (rc.rc == "ok") {
                const tokens_table = rc.tokens.map(token =>
                <tr>
                    <td title="edit" onClick={ () => editToken(token.token) }>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6"><path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" /></svg>
                    </td>
                    <td>{token.token}</td>
                    <td className="italic">{token.type}</td>
                    <td className="font-bold">{token.description}</td>
                    <td>{token.policies}</td>
                    <td>{token.created}</td>
                </tr>
                )
                setTokenList(tokens_table);
            };
        })
    }, [ token, message ]);


    if (page_state.admin_tokens_active) {
    return (

    <div className="space-y-4">
      <div className="flex flex-row gap-4 font-extrabold">
        Manage Access Tokens
      </div>

      <div className="bg-base-100 shadow-xl p-2">
        <div className="overflow-x-auto">
          <table className="table w-full">
            <thead>
              <tr>
                <th className="w-1"></th>
                <th className="w-80">Token</th>
                <th className="w-20">Type</th>
                <th>Description</th>
                <th className="w-80">Policies</th>
                <th className="w-50">Created</th>
              </tr>
            </thead>
            <tbody id="items-table-body">
            { token_list }
            </tbody>
          </table>
        </div>

        <div id="pagination" className="mt-8 flex justify-center">
        </div>
      </div>
    </div>
    );
    }
}
